import type { FC } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { breadCrumbSelector } from "@/features/currentRouteSlice";
import { getUrlFromPath } from "@/routerConfig";
import { useAppSelector } from "@/storeHooks";
import css from "./AppHeader.module.css";

const Breadcrumb: FC<{ testId?: string }> = ({ testId = "breadcrumb" }) => {
  const breadcrumb = useAppSelector(breadCrumbSelector);
  return (
    <nav
      className={css.breadCrumb}
      aria-label="breadcrumbs"
      data-testid={testId}
    >
      {breadcrumb.length > 0 ? (
        <ol>
          {breadcrumb.map((crumb, index) => {
            if (index === breadcrumb.length - 1) {
              return (
                <li key={crumb.label} className={css.breadCrumbText}>
                  {crumb.label}
                </li>
              );
            } else {
              return (
                <li key={crumb.label} className={css.breadCrumbText}>
                  {crumb.path
                    ? (() => {
                        const path = crumb.path.split("?")?.[0] ?? "";
                        return crumb.isInternal ? (
                          <Link to={path}>{crumb.label}</Link>
                        ) : (
                          <a href={getUrlFromPath(path)}>{crumb.label}</a>
                        );
                      })()
                    : crumb.label}
                </li>
              );
            }
          })}
        </ol>
      ) : null}
    </nav>
  );
};

export default Breadcrumb;
